const { PostFormApi, validateInputField } = require("../utils/func");

export const processRegisterForProgram = (e) => {
  e.preventDefault();

  const formFields = document.querySelectorAll(".validate-input");
  const dataValues = document.querySelectorAll(".form-input");
  let validate = [];

  // Run validation
  formFields.forEach(el => validate.push(validateInputField(el)));

  const getSpecialty = document.getElementById("specialty");
  const getSpecialtyInput = document.getElementById("specialtyInput");
  const showSpecialtyError = document.getElementById("invalid-specialty");
  const attendingError = document.getElementById("howAttend");
  const autoEnroll = document.querySelector("input[name='auto-enroll']");

  // Exclude "Select All" checkbox
  //const attendingCheckboxes = Array.from(document.querySelectorAll("input[name='attending']"));
  //console.log("attendingCheckboxes", attendingCheckboxes);

  // Validate specialty
  const specialtyValue = getSpecialty.options[getSpecialty.selectedIndex];
  if (specialtyValue.value === "select") {
    showSpecialtyError.style.display = "block";
    getSpecialty.setAttribute("style", "border: 1px solid #dc3545");
    window.scrollTo({ top: showSpecialtyError.offsetTop, behavior: "smooth" });
    validate.push(1);
  } else {
    showSpecialtyError.style.display = "none";
    getSpecialty.removeAttribute("style");
  }

  // Collect selected programs_id
  /*const attending = attendingCheckboxes
                     .filter(cb => cb.checked)
                     .map(cb => cb.value);*/

 /* function getAttendingPrograms() {
    const all = document.getElementById("attendingAll");

    // If "Select All" is checked, just return all IDs
    if (all && all.checked) {
      return ["95", "96", "97", "98", "99"];
    }

    // Otherwise, collect only the real checkboxes
    return [...document.querySelectorAll('input[name="attending"]:checked')]
      .filter(cb => cb.id !== "attendingAll") // never include the switch
      .map(cb => cb.value);
  }*/
    function getAttendingPrograms() {
      return Array.from(document.querySelectorAll('input[name="attending"]:checked'))
                  .map(cb => cb.value);
    }





    
    const attending = getAttendingPrograms();



    console.log("attending", attending);

  if (attending.length === 0) {
    attendingError.style.backgroundColor = "#f5d7da";
    window.scrollTo({ top: document.querySelector("#invalid-attending").offsetTop, behavior: "smooth" });
    validate.push(1);
  } else {
    attendingError.removeAttribute("style");
  }

  if (validate.length === 0 || validate.indexOf(1) === -1) {

    const specialty = specialtyValue.value === "Other" ? getSpecialtyInput.value.trim() : specialtyValue.value;

    grecaptcha.execute("6LcIJ6cUAAAAABzDuwpRp8UWOkteEUrySZ2cUg1j", { action: "ada_register_for_program" })
      .then((token) => {
        let formData = {};
    

        dataValues.forEach(input => {
          if (input.type === "checkbox") return; // ignore all checkboxes here
          formData[input.getAttribute("name")] = input.value;
        });


        formData.autoEnroll = autoEnroll && autoEnroll.checked ? 1 : 0;
        // Convert the array of program IDs into a comma-separated string
        formData.attending = attending.join(',');

        formData.specialty = specialty;
        formData.token = token;
        formData.submit = true;

        console.log("formData", formData);

        PostFormApi("api/register_for_program/register_for_program.php", formData)
          .done((res) => {
            console.log("API RESPONSE:", res);

            // Update DOM
            const registerHeader = document.getElementById("registerTextHeader");
            const invitationText = document.getElementById("invitationText");
            const showName = document.getElementById("showName");

            if (registerHeader) registerHeader.style.display = "none";
            if (invitationText) invitationText.style.display = "none";

            if ($("#showForm").length) $("#showForm").fadeOut(500);
            if ($("#success").length) $("#success").fadeIn();
          })
          .fail((jqXHR, textStatus, errorThrown) => {
            console.error("API ERROR:", textStatus, errorThrown);
            alert("There was an error submitting the form. Please try again.");
          });
      });
  }
};

// Specialty input box
export const setSpecialtyBox = (e) => {
  const specialtyBox = document.getElementById("specialtyInput");
  if (e.target.value === "Other") {
    specialtyBox.classList.add("validate-input", "form-input");
    specialtyBox.style.display = "block";
  } else {
    specialtyBox.classList.remove("validate-input");
    specialtyBox.style.display = "none";
  }
};

// Select All logic
/*
document.addEventListener("DOMContentLoaded", () => {
  const selectAll = document.getElementById("attendingAll");
  const checkboxes = Array.from(document.querySelectorAll('input[name="attending"]'));

  // Set all checkboxes initially checked
  checkboxes.forEach(cb => cb.checked = true);
  selectAll.checked = true;

  // Select All listener
  selectAll.addEventListener("change", () => {
    checkboxes.forEach(cb => cb.checked = selectAll.checked);
  });

  // Uncheck Select All if any checkbox is unchecked
  checkboxes.forEach(cb => {
    cb.addEventListener("change", () => {
      selectAll.checked = checkboxes.every(c => c.checked);
    });
  });
});
*/
document.addEventListener("DOMContentLoaded", () => {
    const selectAll = document.getElementById("attendingAll");
    const checkboxes = Array.from(document.querySelectorAll('input[name="attending"]'));

    // If this page doesn't have the registration UI, do nothing.
    if (!selectAll || checkboxes.length === 0) return;

    // Set all checkboxes initially checked
    checkboxes.forEach((cb) => (cb.checked = true));
    selectAll.checked = true;

    // Select All listener
    selectAll.addEventListener("change", () => {
        checkboxes.forEach((cb) => (cb.checked = selectAll.checked));
    });

    // Uncheck Select All if any checkbox is unchecked
    checkboxes.forEach((cb) => {
        cb.addEventListener("change", () => {
            selectAll.checked = checkboxes.every((c) => c.checked);
        });
    });
});

